module.exports = __webpack_public_path__ + "img/google.0054ae4b.png";